<template>
  <div>
    <v-container fluid pt-0 grid-list-xl>
      <section-tooltip title="Orderhistory"></section-tooltip>
        <v-data-table v-bind:headers="headers" :items="eventGroupsForCurrentSeason" hide-actions>
          <template slot="items" slot-scope="props">
            <td class="clickable" @click="onClick(props.item.id)"><img :src="`/static/img/country_icons/${props.item.countryCode}.png`"></td>
            <td class="clickable" @click="onClick(props.item.id)">{{ props.item.name }}</td>
          </template>
        </v-data-table>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: {

  },
  components: {

  },
  data() {
    return {
      headers: [
        { text: 'Country', value: 'countryCode', width: 100, sortable: false },
        { text: 'Event group', value: 'name' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'eventGroupsForCurrentSeason'
    ]),
  },
  methods: {
    onClick (id) {
      this.$router.push({ name: 'orderhistory.events', params: { eventgroupId: id }})
    }
  },
  created() {

  }
}
</script>
<style>
    .button-row {
        padding-top: 15px !important;
    }
</style>